/***
 *
 *   IMPERSONATE
 *   Phase 9 — token-pass chrome.
 *
 **********/

import React, { useContext, useEffect, useRef } from 'react';
import { Animate, Message, useNavigate, useLocation } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useApiContext } from 'app/api';
import { useTranslate } from 'app/translations';

export function ImpersonateSignin(props) {
    const { _t } = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const qs = location.search;
    const context = useRef(useContext(AuthContext));
    const { callApi } = useApiContext();

    useEffect(() => {
        const verifyToken = async (token) => {
            try {
                const res = await callApi({
                    url: '/api/auth/impersonate',
                    method: 'post',
                    data: { token: token },
                });

                res.status === 200 ? context.current.signin(res) : navigate('/signin');
            } catch (err) {
                navigate('/signin');
            }
        };

        if (qs.includes('token=')) {
            verifyToken(qs.substring(qs.indexOf('token=') + 6));
        } else {
            navigate('/404');
        }
    }, [qs, navigate, callApi]);

    return (
        <Animate>
            <AuthPage>
                <Message
                    type="info"
                    title={_t('signin.loading')}
                    text="Signing you in via Mission Control"
                />
            </AuthPage>
        </Animate>
    );
}
